<template>
  <q-layout
    view="lHh Lpr lff"
    class="overflow-hidden bg-200 text-neutral-70 pl-[var(--Nv0-sidebar-width)]"
  >
    <MenuMultiLevel :menu-list="menuList(t)" />

    <HeaderBase />

    <q-page-container class="">
      <q-page class="flex flex-col container-base mx-auto !p-0">
        <router-view />
      </q-page>
    </q-page-container>

    <DevTricksCard v-if="DEV" />
  </q-layout>
</template>

<script setup>
import { DEV } from 'js/utils/constants/app'
import { useI18n } from 'vue-i18n'
import DevTricksCard from 'components/Dev/DevTricksCard.vue'
import HeaderBase from 'components/Admin/Header/HeaderBase.vue'
import menuList from 'js/utils/admin/menuList'
import MenuMultiLevel from 'components/Admin/Menu/MenuMultiLevel.vue'

const { t } = useI18n()
</script>

<style lang="sass" scoped></style>
